import { defineComponent, toRefs } from 'vue';
import { getCompanyMemberById, saveCompanyMember } from '@/api/company/companyMemberApi';
import { useRequestApi } from '@/composition/fetch/index';
import { useMemberForm } from '@/views/member/composition/useMemberForm';
export default defineComponent({
    name: 'MemberInfo',
    components: {
        Label: () => import('@/components/form/Label/index.vue'),
        UserRoleSelect: () => import('@/components/form/UserRoleSelector.vue')
    },
    props: {
        memberSeq: {
            type: [Number, String],
            required: true
        },
        companyId: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const { state, request } = useRequestApi(getCompanyMemberById, {});
        const { form, setForm, loading: saveLoading, rules, save } = useMemberForm(saveCompanyMember);
        const { loading, data } = toRefs(state);
        request(props.memberSeq).then((form) => setForm({ valid: true, ...form }));
        return {
            form,
            loading,
            saveLoading,
            rules,
            data,
            save
        };
    }
});
